// Require stylesheet
import 'stylesheets/signup.scss';

// Require all images to be rendered by Rails views
require.context('images', true);

import { initRecaptcha } from 'recaptcha';
import { setupSignUpPasswordInput } from 'sign_up/password_input';
import { setupSignUpCompanyInputs } from 'sign_up/company_inputs';

document.addEventListener('DOMContentLoaded', () => {
  initRecaptcha();
  setupSignUpPasswordInput();
  setupSignUpCompanyInputs();
});
